import { Injectable } from '@angular/core';

declare let gtag: Function; // Declare ga as a function

@Injectable()
export class GoogleAnalyticsService {

    constructor() { }

    public eventEmitter(eventAction: string,
        eventCategory: string,
        eventLabel: string = null,
        eventValue: number = null) {
        gtag('event', eventAction, {
            event_category: eventCategory,
            event_label: eventLabel,
            value: eventValue
        });

    }

}
